<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between align-items-center catalogo-text text-sm"
          >
            Catálogo de empaques
            <router-link :to="{ name: 'NuevoEmpaques' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Empaque
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #cultivo="{item}">
                <td class="py-2">{{ item.payload.cultivo }}</td>
              </template>
              <template #costo="{item}">
                <td class="py-2">{{ $formatter(item.payload.costo||0,true) }}</td>
              </template>
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por empaques..."
                />
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditarEmpaques',
                      params: { id: item.id }
                    }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton color="danger" square size="sm" @click="toggleCancel(index, item)">Borrar</CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Empaques"
      color="danger"
    >
      <h5 class="text-center">¿Deseas borrar el empaques {{ itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Borrar Empaques</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="deleteCultivo(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "nombre", label: "Nombre", _style: "width:33%" },
  { key: "cultivo", label: "Cultivo", _style: "width:33%" },
  { key: "costo", label: "Costo", _style: "width:33%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Empaques",

  data() {
    return {
      items: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      error: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      text: "",
    };
  },

  created() {
    this.isLoading = true;
    this.$store
      .dispatch("customHTTP", {
        schema: "empaques",
        limit: 50,
        page: 1,
        ["with-storage"]: ["*"]
      })
      .then(res => {
        this.items = res.data;
        this.pages = res.paginate.last_page;
        this.page = res.paginate.current_page;
      })
      .catch(err => console.log(err))

      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(i =>
        i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text,page=1) {
      this.text = text
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "empaques",
          limit: 50,
          page: page,
          filter: {
            orwhere: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "payload->cultivo",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "payload->costo",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.updateItemsSearch(this.filter.toUpperCase(),event);
    },

    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteCultivo(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "empaques",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
